import { http } from '@/lib/http';
import type {
    ReviewPresencePutRequest,
    ReviewPresencePutResponse,
} from '@shared/review-presence-api';

export async function putReviewPresence(
    body: ReviewPresencePutRequest,
): Promise<ReviewPresencePutResponse | null> {
    try {
        const response = await http('/api/review/presence', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            if (import.meta.env.DEV) {
                console.warn('[REVIEW_PRESENCE] PUT failed', { status: response.status, intent: body.intent });
            }
            return null;
        }
        return (await response.json()) as ReviewPresencePutResponse;
    } catch (error) {
        if (import.meta.env.DEV) {
            console.warn('[REVIEW_PRESENCE] PUT error', error);
        }
        return null;
    }
}
